
import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter, ListingOrderBy } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';
import { API } from 'client-website-ts-library/services';
import { WebsiteLevel } from 'client-website-ts-library/types';

import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
  },
})
export default class OfficePropertiesForSale extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  handleFilter(filter: ListingFilter) {
    const id = this.$route.params.id;
    if (id) {
      API.Slugs.Resolve(id).then((resolved) => {
        if (resolved.Type === 'Office') {
          // City
          if (resolved.Id === '91b553f9-7cbc-4697-bf7d-d70714b674a4') {
            // eslint-disable-next-line no-param-reassign
            filter.SearchLevel = WebsiteLevel.Office;
            // eslint-disable-next-line no-param-reassign
            filter.SearchGuid = '91b553f9-7cbc-4697-bf7d-d70714b674a4';
          }

          // Redlynch
          if (resolved.Id === 'f2c947c3-1b35-41ce-8380-54f0ff32cd52') {
            // eslint-disable-next-line no-param-reassign
            filter.SearchLevel = WebsiteLevel.Office;
            // eslint-disable-next-line no-param-reassign
            filter.SearchGuid = 'f2c947c3-1b35-41ce-8380-54f0ff32cd52';
          }

          // South
          if (resolved.Id === 'f9d229bb-51ff-4b83-94eb-4877c1c736d2') {
            // eslint-disable-next-line no-param-reassign
            filter.SearchLevel = WebsiteLevel.Profile;
            // eslint-disable-next-line no-param-reassign
            filter.SearchGuid = 'dbc21df2-268d-43da-a26c-da5711f7ee39';
          }
        }
        // eslint-disable-next-line no-param-reassign
        filter.OrderByStatements = [ListingOrderBy.CreateDateDesc];
        this.listingFilter = filter;
      });
    }
  }
}
